import type { HubAlert } from '../hubAlertRules';

/** Title without a trailing "· Facility" when the facility is shown separately. */
export const alertTitle = (alert: HubAlert, withFacility: boolean) =>
  withFacility && alert.facilityName && alert.title.endsWith(` · ${alert.facilityName}`)
    ? alert.title.slice(0, -` · ${alert.facilityName}`.length)
    : alert.title;

export const detailLine = (alert: HubAlert) =>
  alert.details.length > 0
    ? alert.details.map(detail => `${detail.label}: ${detail.value}`).join(' · ')
    : alert.body;

/** "now", "4 min", "2 h", or the clock time for older ones (same working day). */
export const relativeTime = (at: number, now = Date.now()) => {
  const minutes = Math.floor((now - at) / 60_000);
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 180) return `${Math.floor(minutes / 60)} h`;
  return new Date(at).toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' });
};

/** A modal (picking, QC, forms) is open on the page: work in progress. */
export const isModalOpen = () =>
  typeof document !== 'undefined' &&
  Array.from(document.querySelectorAll<HTMLElement>('.ant-modal-wrap')).some(
    // Closed antd modals stay in the DOM hidden (fixed elements have no offsetParent to test).
    wrap => wrap.style.display !== 'none' && Boolean(wrap.querySelector('.ant-modal')),
  );

/** A packing task guards navigation and asks by itself before unsaved work is left. */
export const isTaskGuarded = () =>
  typeof document !== 'undefined' && Boolean(document.documentElement.dataset.packingGuard);

/**
 * Pressing an alert button (bar, bell) must not move focus off the task (the scan box): the next
 * barcode scan has to land where it did before the alert.
 */
export const keepFocus = (event: { preventDefault: () => void }) => event.preventDefault();
